export default {
  gray: {
    50: '#fafafa',
    100: '#f4f4f5',
    200: '#e4e4e7',
    300: '#d4d4d8',
    400: '#a1a1aa',
    500: '#71717a',
    600: '#52525b',
    700: '#3f3f46',
    800: '#27272a',
    900: '#18181b',
    950: '#09090b',
  },
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#1E69AC',
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
    950: '#052e16',
  },
  yellow: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
    950: '#422006',
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    950: '#450a0a',
  },
  orange: {
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#b91c1c',
    800: '#9a3412',
    900: '#7c2d12',
    950: '#431407',
  },
  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87',
    950: '#3b0764',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
    950: '#042f2e',
  },
  brand: {
    50: '#eef6fc',
    100: '#d9eaf7',
    200: '#b7d7ee',
    300: '#8cc0e2',
    400: '#5fa3d3',
    500: '#1f74ba',
    600: '#1b68a7',
    700: '#17578b',
    800: '#12466f',
    900: '#0d3553',
    950: '#08213a',
  },
  base: {
    white: '#ffffff',
    black: '#000000',
    transparent: '#00000000',
  },
  overlay: {
    'black-7': '#00000012',
    'black-10': '#0000001a',
    'black-20': '#00000033',
    'black-30': '#0000004d',
    'black-50': '#00000080',
    'black-70': '#000000b2',
    'white-7': '#FFFFFF12',
    'white-10': '#ffffff1a',
    'white-20': '#ffffff33',
    'white-30': '#ffffff4d',
    'white-50': '#ffffff80',
    'white-70': '#ffffffb2',
  },
  opacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    80: '0.8',
    90: '0.9',
    100: '1',
  },
  spacing: {
    0: '0',
    1: '4',
    2: '8',
    3: '12',
    4: '16',
    5: '20',
    6: '24',
    7: '28',
    8: '32',
    9: '36',
    10: '40',
    12: '48',
    16: '64',
    20: '80',
    24: '96',
  },
  sizing: {
    4: '4',
    8: '8',
    12: '12',
    16: '16',
    20: '20',
    24: '24',
    32: '32',
    36: '36',
    40: '40',
    44: '44',
    48: '48',
    56: '56',
    64: '64',
    80: '80',
    96: '96',
    120: '120',
  },
  radius: {
    rounded: {
      none: '0',
      xs: '8',
      sm: '12',
      md: '16',
      lg: '20',
      xl: '24',
      '2xl': '32',
      '3xl': '40',
      full: '9999',
    },
    radius: {
      0: '0',
      1: '1',
      2: '2',
      3: '3',
      4: '4',
    },
    none: {
      xs: '0',
      sm: '0',
      md: '0',
      lg: '0',
      xl: '0',
      '2xl': '0',
      '3xl': '0',
      pill: '4',
    },
  },
  stroke: {
    0: '0',
    1: '1',
    2: '2',
    4: '4',
    8: '8',
  },
  typography: {
    fontFamily: {
      body: 'Roboto',
      heading: 'Roboto',
      code: 'Roboto Mono',
      mono: 'Roboto Mono',
    },
    fontSize: {
      '2xs': '10',
      xs: '12',
      sm: '14',
      md: '16',
      lg: '18',
      xl: '20',
      '2xl': '24',
      '3xl': '28',
      '4xl': '32',
      '5xl': '40',
    },
    fontWeight: {
      regular: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
    lineHeight: {
      '2xs': '14',
      xs: '16',
      sm: '20',
      md: '24',
      lg: '28',
      xl: '32',
      '2xl': '36',
      '3xl': '40',
      '4xl': '48',
      '5xl': '56',
    },
    letterSpacing: {
      tighter: '-5',
      tight: '-2.5',
      normal: '0',
      wide: '2.5',
    },
    paragraphSpacing: {
      none: '0',
      sm: '4',
      md: '8',
      lg: '12',
    },
    paragraphIndent: {
      none: '0',
    },
  },
} as const;
